import { StrictMode } from "react";
import { createReactRoot } from "common/react/create-react-root";

import { TechReportPicker } from "./TechReportPicker";

const SELECTOR = "#tech-report-picker-app";

/* v8 ignore start -- mount wrapper tested by E2E, not unit tests */
export function initTechReportPicker(selector = SELECTOR) {
  const mountPoint = document.querySelector(selector) as HTMLElement | null;
  if (!mountPoint || mountPoint.dataset["reactRoot"]) return;

  mountPoint.dataset["reactRoot"] = "true";

  const propsEl = mountPoint.querySelector("[data-component-props]") as HTMLElement | null;
  const dataset = propsEl?.dataset ?? mountPoint.dataset;

  const root = createReactRoot(mountPoint, "Tech Report Picker");
  root.render(
    <StrictMode>
      <TechReportPicker
        defectiveHref={dataset["defectiveHref"] || ""}
        lateHref={dataset["lateHref"] || ""}
        storeCode={dataset["storeCode"] || ""}
      />
    </StrictMode>
  );
}
/* v8 ignore end */

// eslint-disable-next-line import/no-default-export
export default initTechReportPicker;
